(function() {
  var wizardEl = document.getElementById('cv-diagnostic-wizard');
  if (!wizardEl) return;

  var BACKEND_URL = wizardEl.getAttribute('data-backend-url') || '';
  if (BACKEND_URL && BACKEND_URL.endsWith('/')) {
    BACKEND_URL = BACKEND_URL.slice(0, -1);
  }

  var IS_MAYORISTA = wizardEl.getAttribute('data-is-mayorista') === 'true';
  var parsedDiscount = parseFloat(wizardEl.getAttribute('data-discount-percent'));
  var DISCOUNT_PERCENT = isNaN(parsedDiscount) ? 15 : parsedDiscount;
  var DISCOUNT_MULTIPLIER = 1 - (DISCOUNT_PERCENT / 100);

  var CR_API_BASE = wizardEl.getAttribute('data-celorecomiendo-api') || '';
  if (CR_API_BASE && CR_API_BASE.endsWith('/')) {
    CR_API_BASE = CR_API_BASE.slice(0, -1);
  }
  var CUSTOMER_GID = wizardEl.getAttribute('data-customer-gid') || '';

  // Cache /products/{handle}.js fetches so multiple piezas with the same product reuse data.
  var productInfoCache = {};
  function fetchProductInfo(handle) {
    if (!handle) return Promise.reject(new Error('no handle'));
    if (productInfoCache[handle]) return productInfoCache[handle];
    var localeRoot = (window.theme && window.theme.localeRootUrl) || '';
    productInfoCache[handle] = fetch(localeRoot + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .catch(function(err) { delete productInfoCache[handle]; throw err; });
    return productInfoCache[handle];
  }

  var IPHONE_SUBMODELS = {
    'iPhone 11': ['iPhone 11', 'iPhone 11 Pro', 'iPhone 11 Pro Max'],
    'iPhone 12': ['iPhone 12', 'iPhone 12 mini', 'iPhone 12 Pro', 'iPhone 12 Pro Max'],
    'iPhone 13': ['iPhone 13', 'iPhone 13 mini', 'iPhone 13 Pro', 'iPhone 13 Pro Max'],
    'iPhone 14': ['iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max'],
    'iPhone 15': ['iPhone 15', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15 Pro Max'],
    'iPhone 16': ['iPhone 16', 'iPhone 16 Plus', 'iPhone 16 Pro', 'iPhone 16 Pro Max']
  };

  var SAMSUNG_SUBMODELS = {
    'Galaxy S21': ['Galaxy S21', 'Galaxy S21+', 'Galaxy S21 Ultra', 'Galaxy S21 FE'],
    'Galaxy S22': ['Galaxy S22', 'Galaxy S22+', 'Galaxy S22 Ultra'],
    'Galaxy S23': ['Galaxy S23', 'Galaxy S23+', 'Galaxy S23 Ultra', 'Galaxy S23 FE'],
    'Galaxy S24': ['Galaxy S24', 'Galaxy S24+', 'Galaxy S24 Ultra', 'Galaxy S24 FE'],
    'Galaxy S25': ['Galaxy S25', 'Galaxy S25+', 'Galaxy S25 Ultra', 'Galaxy S25 Edge'],
    'Galaxy S26': ['Galaxy S26', 'Galaxy S26+', 'Galaxy S26 Ultra', 'Galaxy S26 Edge']
  };

  var SUBMODELS_BY_BRAND = {
    'Apple': IPHONE_SUBMODELS,
    'Samsung': SAMSUNG_SUBMODELS
  };

  var STATIC_MODELS = {
    'Apple': ['iPhone 16', 'iPhone 15', 'iPhone 14', 'iPhone 13', 'iPhone 12', 'iPhone 11', 'iPhone SE'],
    'Samsung': ['Galaxy S26', 'Galaxy S25', 'Galaxy S24', 'Galaxy S23', 'Galaxy S22', 'Galaxy S21', 'Galaxy A54', 'Galaxy A34', 'Galaxy A14', 'Galaxy Z Flip 5', 'Galaxy Z Fold 5'],
    'Xiaomi': ['Redmi Note 13', 'Redmi Note 12', 'Poco X6', 'Poco F5', 'Mi 14', 'Redmi 13C'],
    'Motorola': ['Moto G84', 'Moto G54', 'Moto Edge 40', 'Moto G Power', 'Moto Razr 40'],
    'Huawei': ['P60 Pro', 'Nova 11', 'Mate 60', 'P50 Pro'],
    'OnePlus': ['12', '11', 'Nord 3', 'Nord CE 3'],
    'Google Pixel': ['Pixel 8 Pro', 'Pixel 8', 'Pixel 7a', 'Pixel 7'],
    'Otro': ['Escribir modelo...']
  };
  var STATIC_BRANDS = Object.keys(STATIC_MODELS).filter(function(b) { return b !== 'Otro'; });

  var dynamicOptions = null;
  var dynamicOptionsLoading = false;

  function loadDiagnoseOptions() {
    if (dynamicOptions || dynamicOptionsLoading || !BACKEND_URL) return;
    dynamicOptionsLoading = true;
    fetch(BACKEND_URL + '/diagnose-options')
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        if (data && Array.isArray(data.brands) && data.brands.length > 0 && data.models_by_brand && typeof data.models_by_brand === 'object') {
          dynamicOptions = data;
          if (state.step === 0) initStep0();
        }
        dynamicOptionsLoading = false;
      })
      .catch(function() {
        dynamicOptionsLoading = false;
      });
  }

  function getDiagnoseBrands() {
    if (dynamicOptions && dynamicOptions.brands && dynamicOptions.brands.length > 0) {
      return dynamicOptions.brands;
    }
    return STATIC_BRANDS;
  }

  function getBaseModelForBrand(brand, modelName) {
    var table = SUBMODELS_BY_BRAND[brand];
    if (!table) return null;
    for (var key in table) {
      if (!table.hasOwnProperty(key)) continue;
      var variants = table[key];
      for (var v = 0; v < variants.length; v++) {
        if (modelName === variants[v]) return key;
      }
    }
    return null;
  }

  function simplifyModelsForBrand(brand, models) {
    var seen = {};
    var result = [];
    for (var i = 0; i < models.length; i++) {
      var m = models[i];
      var base = getBaseModelForBrand(brand, m);
      var display = base || m;
      if (!seen[display]) {
        seen[display] = true;
        result.push(display);
      }
    }
    return result;
  }

  function getDiagnoseModels(brand) {
    var models;
    if (dynamicOptions && dynamicOptions.models_by_brand && Array.isArray(dynamicOptions.models_by_brand[brand])) {
      var dynamic = dynamicOptions.models_by_brand[brand];
      if (dynamic.length > 0) {
        models = dynamic;
      }
    }
    if (!models) {
      models = (STATIC_MODELS[brand] || STATIC_MODELS['Otro'] || []).filter(function(m) {
        return m !== 'Escribir modelo...';
      });
    }
    if (SUBMODELS_BY_BRAND[brand]) {
      return simplifyModelsForBrand(brand, models);
    }
    return models;
  }

  var SYMPTOMS = [
    { id: 'pantalla_rota', label: 'Pantalla rota o estrellada' },
    { id: 'no_enciende', label: 'No enciende la pantalla' },
    { id: 'bateria', label: 'Se descarga muy rápido' },
    { id: 'no_carga', label: 'No carga' },
    { id: 'audio', label: 'No se escucha / audio' },
    { id: 'camara', label: 'Cámara no funciona' },
    { id: 'agua', label: 'Se mojó / cayó al agua' },
    { id: 'botones', label: 'Botones no responden' },
    { id: 'touch', label: 'Touch fantasma / no responde' },
    { id: 'senal', label: 'Sin señal / WiFi' }
  ];

  var DETAILS = {
    'pantalla_rota': ['Se ve la imagen bien', 'Manchas negras en pantalla', 'El touch no funciona', 'Solo la parte de arriba'],
    'no_enciende': ['Suena pero no se ve nada', 'No prende del todo', 'Se queda en logo', 'Pantalla parpadea'],
    'bateria': ['Dura menos de 2 horas', 'Se apaga de repente', 'Batería inflada', 'Se calienta mucho'],
    'no_carga': ['El cable no hace contacto', 'Carga muy lento', 'Solo carga inalámbrico', 'No reconoce el cargador'],
    'audio': ['Altavoz no suena', 'Micrófono no funciona', 'Audio distorsionado', 'Auricular no se escucha'],
    'camara': ['Foto borrosa', 'Cámara trasera negra', 'Cámara frontal negra', 'Flash no funciona'],
    'agua': ['Funciona pero raro', 'Pantalla con manchas', 'No enciende', 'Audio distorsionado'],
    'botones': ['Botón de encendido', 'Volumen', 'Botón home', 'Vibrador no funciona'],
    'touch': ['Toca solo en zonas', 'Se tocan cosas solas', 'No responde al touch', 'Touch retrasado'],
    'senal': ['Sin señal celular', 'WiFi no conecta', 'Bluetooth no funciona', 'GPS no funciona']
  };

  var state = {
    step: 0,
    brand: '',
    model: '',
    baseModel: '',
    submodelActive: false,
    symptom: '',
    symptomLabel: '',
    detail: ''
  };

  var overlay = document.getElementById('cv-diagnostic-overlay');
  var trigger = document.getElementById('cv-diagnostic-trigger');
  var heroCta = document.getElementById('cv-hero-cta');
  var closeBtn = document.getElementById('cv-modal-close');
  var progressContainer = document.getElementById('cv-progress');
  var backBtn = document.getElementById('cv-back-btn');
  var steps = wizardEl.querySelectorAll('.cv-step');
  var loadingEl = document.getElementById('cv-loading');
  var resultsEl = document.getElementById('cv-results');



  function openModal() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    loadDiagnoseOptions();
    prefetchCelorecomiendoLocation();
  }

  // Kick off Celorecomiendo location resolution AND a background workshops
  // prefetch as soon as the wizard opens, so the "¿Quién te lo instala?" panel
  // can render instantly when the user reaches it. We deliberately do NOT
  // trigger the browser geolocation prompt here (only reuse a previously
  // confirmed location). The workshops fetch runs without product context
  // (product depends on the diagnosis); when Celorecomiendo later mounts with
  // a product it will use those cached workshops as the first paint and
  // refine with the product-specific fetch.
  function prefetchCelorecomiendoLocation() {
    if (!CR_API_BASE) return;
    var tries = 0;
    function attempt() {
      if (window.Celorecomiendo && typeof window.Celorecomiendo.prefetchLocation === 'function') {
        try {
          window.Celorecomiendo.prefetchLocation();
          if (typeof window.Celorecomiendo.prefetch === 'function') {
            window.Celorecomiendo.prefetch({ apiBase: CR_API_BASE, customerGid: CUSTOMER_GID });
          }
        } catch (e) { /* silent */ }
        return;
      }
      if (tries++ < 20) setTimeout(attempt, 100);
    }
    attempt();
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (trigger) {
    trigger.addEventListener('click', function() {
      openModal();
    });
  }

  if (heroCta) {
    heroCta.addEventListener('click', function(e) {
      if (e.target.closest('[data-beta-tooltip]')) return;
      openModal();
    });
    heroCta.addEventListener('keydown', function(e) {
      if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('[data-beta-tooltip]')) {
        e.preventDefault();
        openModal();
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      closeModal();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeModal();
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) {
      closeModal();
    }
  });

  var BETA_MSG = 'Este es un sistema nuevo con el que estamos experimentando. No sustituye un diagnóstico hecho por un profesional — úsalo como guía.';
  var betaPills = document.querySelectorAll('[data-beta-tooltip]');
  function closeBetaTooltips() {
    var tips = document.querySelectorAll('.cv-beta-tooltip');
    for (var i = 0; i < tips.length; i++) tips[i].parentNode.removeChild(tips[i]);
    for (var j = 0; j < betaPills.length; j++) betaPills[j].setAttribute('aria-expanded', 'false');
  }
  for (var bp = 0; bp < betaPills.length; bp++) {
    betaPills[bp].setAttribute('aria-expanded', 'false');
    (function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var existing = pill.querySelector('.cv-beta-tooltip');
        if (existing) {
          existing.parentNode.removeChild(existing);
          pill.setAttribute('aria-expanded', 'false');
          return;
        }
        closeBetaTooltips();
        var tip = document.createElement('span');
        tip.className = 'cv-beta-tooltip';
        tip.setAttribute('role', 'tooltip');
        tip.textContent = BETA_MSG;
        tip.addEventListener('click', function(ev) { ev.stopPropagation(); });
        pill.appendChild(tip);
        pill.setAttribute('aria-expanded', 'true');
      });
    })(betaPills[bp]);
  }
  document.addEventListener('click', function() { closeBetaTooltips(); });

  function getTotalSteps() {
    return state.submodelActive ? 5 : 4;
  }

  function getLogicalStep(physicalStep) {
    if (!state.submodelActive && physicalStep >= 2) return physicalStep - 1;
    return physicalStep;
  }

  function updateProgress() {
    var total = getTotalSteps();
    var logical = getLogicalStep(state.step);
    var dots = '';
    for (var i = 0; i < total; i++) {
      var cls = 'cv-progress-dot';
      if (i < logical) cls += ' done';
      else if (i === logical) cls += ' current';
      dots += '<div class="' + cls + '"></div>';
    }
    progressContainer.innerHTML = dots;
  }

  function updateStepLabel(stepEl) {
    if (!stepEl) return;
    var label = stepEl.querySelector('.cv-step-label');
    if (!label) return;
    var total = getTotalSteps();
    var logical = getLogicalStep(parseInt(stepEl.getAttribute('data-step') || '0', 10));
    label.textContent = 'Paso ' + (logical + 1) + ' de ' + total;
  }

  function showStep(stepIndex) {
    state.step = stepIndex;
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('active');
    }
    if (steps[stepIndex]) {
      steps[stepIndex].classList.add('active');
      updateStepLabel(steps[stepIndex]);
    }
    updateProgress();
    backBtn.style.display = stepIndex > 0 ? 'block' : 'none';
    loadingEl.classList.remove('visible');
    resultsEl.classList.remove('visible');
  }

  function renderPills(container, items, onClick, otherPlaceholder) {
    container.innerHTML = '';

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'cv-pill';
      pill.textContent = typeof item === 'string' ? item : item.label;
      (function(currentItem, currentPill) {
        currentPill.addEventListener('click', function() {
          var allPills = container.querySelectorAll('.cv-pill');
          for (var j = 0; j < allPills.length; j++) {
            allPills[j].classList.remove('selected');
          }
          currentPill.classList.add('selected');
          var inlineInput = container.querySelector('.cv-inline-input');
          if (inlineInput) inlineInput.querySelector('input').value = '';
          setTimeout(function() {
            onClick(currentItem);
          }, 200);
        });
      })(item, pill);
      container.appendChild(pill);
    }

    if (otherPlaceholder) {
      var inlineRow = document.createElement('div');
      inlineRow.className = 'cv-inline-input';
      var inlineField = document.createElement('input');
      inlineField.type = 'text';
      inlineField.placeholder = otherPlaceholder;
      inlineField.className = 'cv-inline-input__field';
      var inlineBtn = document.createElement('button');
      inlineBtn.type = 'button';
      inlineBtn.className = 'cv-inline-input__btn';
      inlineBtn.textContent = '→';
      inlineBtn.addEventListener('click', function() {
        var val = inlineField.value.trim();
        if (val) {
          var allPills = container.querySelectorAll('.cv-pill');
          for (var j = 0; j < allPills.length; j++) {
            allPills[j].classList.remove('selected');
          }
          onClick({ __typed__: true, value: val });
        } else {
          inlineField.focus();
        }
      });
      inlineField.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          inlineBtn.click();
        }
      });
      inlineField.addEventListener('focus', function() {
        var allPills = container.querySelectorAll('.cv-pill');
        for (var j = 0; j < allPills.length; j++) {
          allPills[j].classList.remove('selected');
        }
      });
      inlineRow.appendChild(inlineField);
      inlineRow.appendChild(inlineBtn);
      container.appendChild(inlineRow);
    }
  }

  function initStep0() {
    var brands = getDiagnoseBrands();
    var container = document.getElementById('cv-brand-pills');
    renderPills(container, brands, function(brand) {
      var val = (brand && brand.__typed__) ? brand.value : brand;
      state.brand = val;
      initStep1();
      showStep(1);
    }, 'Escribe otra marca...');
  }

  function hasSubmodels(brand, modelName) {
    var table = SUBMODELS_BY_BRAND[brand];
    return !!(table && table.hasOwnProperty(modelName));
  }

  function initStep1() {
    var models = getDiagnoseModels(state.brand);
    var container = document.getElementById('cv-model-pills');
    renderPills(container, models, function(model) {
      var val = (model && model.__typed__) ? model.value : model;
      if (hasSubmodels(state.brand, val)) {
        state.baseModel = val;
        state.submodelActive = true;
        initStep1b();
        showStep(2);
      } else {
        state.baseModel = '';
        state.submodelActive = false;
        state.model = val;
        initStep2();
        showStep(3);
      }
    }, 'Escribe otro modelo...');
    resetImeiSection();
  }

  function initStep1b() {
    var table = SUBMODELS_BY_BRAND[state.brand] || {};
    var variants = table[state.baseModel] || [];
    var container = document.getElementById('cv-submodel-pills');
    renderPills(container, variants, function(submodel) {
      var val = (submodel && submodel.__typed__) ? submodel.value : submodel;
      state.model = val;
      initStep2();
      showStep(3);
    }, 'Escribe otro modelo...');
  }

  function initStep2() {
    var container = document.getElementById('cv-symptom-pills');
    renderPills(container, SYMPTOMS, function(symptom) {
      if (symptom && symptom.__typed__) {
        state.symptom = symptom.value;
        state.symptomLabel = symptom.value;
      } else {
        state.symptom = symptom.id;
        state.symptomLabel = symptom.label;
      }
      initStep3();
      showStep(4);
    }, 'Describe otro problema...');
  }

  function initStep3() {
    var details = DETAILS[state.symptom] || [];
    var container = document.getElementById('cv-detail-pills');
    renderPills(container, details, function(detail) {
      var val = (detail && detail.__typed__) ? detail.value : detail;
      state.detail = val;
      runDiagnosis();
    }, 'Escribe otro detalle...');
  }

  var imeiInput = document.getElementById('diagnosis-imei-input');
  var imeiBtn = document.getElementById('diagnosis-imei-btn');
  var imeiStatus = document.getElementById('diagnosis-imei-status');

  function resetImeiSection() {
    if (imeiInput) imeiInput.value = '';
    if (imeiStatus) { imeiStatus.innerHTML = ''; imeiStatus.className = 'cv-imei-status'; }
    if (imeiBtn) { imeiBtn.disabled = false; imeiBtn.textContent = 'Buscar'; }
  }

  function handleImeiLookup() {
    if (!imeiInput || !BACKEND_URL) return;
    var raw = imeiInput.value.replace(/[\s\-]/g, '');
    if (!/^\d{15}$/.test(raw)) {
      if (imeiStatus) {
        imeiStatus.innerHTML = 'El IMEI debe tener exactamente 15 dígitos';
        imeiStatus.className = 'cv-imei-status cv-imei-status--error';
      }
      return;
    }
    if (imeiBtn) { imeiBtn.disabled = true; imeiBtn.textContent = 'Buscando...'; }
    if (imeiStatus) {
      imeiStatus.innerHTML = '<span class="cv-imei-loading-dots"><span></span><span></span><span></span></span> Consultando IMEI...';
      imeiStatus.className = 'cv-imei-status cv-imei-status--loading';
    }
    fetch(BACKEND_URL + '/resolve-imei', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ imei: raw })
    })
    .then(function(r) {
      if (r.status === 400) throw { code: 400, msg: 'IMEI inválido. Verifica que sean 15 dígitos correctos.' };
      if (r.status === 404) throw { code: 404, msg: 'No se encontró el modelo para ese IMEI. Puedes escribirlo manualmente.' };
      if (r.status === 502 || r.status === 504) throw { code: r.status, msg: 'El servicio de IMEI no está disponible. Intenta más tarde o escribe tu modelo.' };
      if (!r.ok) throw { code: r.status, msg: 'Error al consultar IMEI. Intenta de nuevo.' };
      return r.json();
    })
    .then(function(data) {
      if (data.model) {
        if (imeiStatus) {
          imeiStatus.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg> Modelo detectado: <strong>' + escapeHtml(data.model) + '</strong>';
          imeiStatus.className = 'cv-imei-status cv-imei-status--success';
        }
        if (imeiBtn) { imeiBtn.disabled = false; imeiBtn.textContent = 'Buscar'; }
        state.model = data.model;
        state.baseModel = '';
        state.submodelActive = false;
        setTimeout(function() {
          initStep2();
          showStep(3);
        }, 1200);
      } else {
        throw { msg: 'No se pudo detectar el modelo. Escríbelo manualmente.' };
      }
    })
    .catch(function(err) {
      var msg = (err && err.msg) ? err.msg : 'Error al consultar IMEI. Intenta de nuevo.';
      if (imeiStatus) {
        imeiStatus.innerHTML = msg;
        imeiStatus.className = 'cv-imei-status cv-imei-status--error';
      }
      if (imeiBtn) { imeiBtn.disabled = false; imeiBtn.textContent = 'Buscar'; }
    });
  }

  if (imeiBtn) {
    imeiBtn.addEventListener('click', handleImeiLookup);
  }
  if (imeiInput) {
    imeiInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); handleImeiLookup(); }
    });
  }

  function runDiagnosis() {
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('active');
    }
    backBtn.style.display = 'none';
    loadingEl.classList.add('visible');

    if (!BACKEND_URL) {
      fallbackSearch();
      return;
    }

    fetch(BACKEND_URL + '/diagnose', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        brand: state.brand,
        model: state.model,
        symptom: state.symptom,
        detail: state.detail
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    })
    .then(function(data) {
      enrichProductHandles(data);
      renderDiagnosis(data);
    })
    .catch(function(error) {
      console.error('[celovendo diagnóstico]', error);
      fallbackSearch();
    });
  }

  function enrichProductHandles(data) {
    if (!data || !data.piezas) return;
    data.piezas.forEach(function(pieza) {
      if (!pieza.productos) return;
      pieza.productos.forEach(function(prod) {
        if (prod.handle) return;
        if (prod.slug) {
          prod.handle = prod.slug;
          return;
        }
        if (prod.url) {
          var urlMatch = prod.url.match(/\/products\/([^?#]+)/);
          if (urlMatch) prod.handle = urlMatch[1];
        }
      });
    });
  }

  function fallbackSearch() {
    var query = state.symptomLabel + ' ' + state.brand + ' ' + state.model;
    window.location.href = '/search?q=' + encodeURIComponent(query);
  }

  function filterPiezas(piezas) {
    if (!piezas || !piezas.length) return [];

    var highConf = piezas.filter(function(p) {
      return (p.probabilidad === 'muy_probable' || p.probabilidad === 'probable') && p.productos && p.productos.length > 0;
    });

    if (highConf.length > 0) return highConf;

    var posible = piezas.filter(function(p) {
      return p.probabilidad === 'posible' && p.productos && p.productos.length > 0;
    });

    if (posible.length > 0) return posible;

    return [];
  }

  function renderDiagnosis(data) {
    loadingEl.classList.remove('visible');
    resultsEl.classList.add('visible');

    var filteredPiezas = filterPiezas(data.piezas);
    var hasResults = filteredPiezas.length > 0;

    var html = '';
    html += '<div class="cv-results-header">';
    html += '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#ff9b00" stroke-width="2"/><path d="M8 12l3 3 5-5" stroke="#ff9b00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    html += '<h3>Diagnóstico para ' + escapeHtml(state.brand) + ' ' + escapeHtml(state.model) + '</h3>';
    html += '</div>';

    if (data.diagnostico) {
      html += '<div class="cv-diagnosis-text">' + escapeHtml(data.diagnostico) + '</div>';
    }

    if (hasResults) {
      filteredPiezas.forEach(function(pieza) {
        html += '<div class="cv-pieza">';
        html += '<div class="cv-pieza-header">';
        html += '<span class="cv-pieza-name">' + escapeHtml(pieza.nombre) + '</span>';
        html += renderBadge(pieza.probabilidad);
        html += '</div>';
        if (pieza.descripcion) {
          html += '<p class="cv-pieza-desc">' + escapeHtml(pieza.descripcion) + '</p>';
        }
        if (pieza.productos && pieza.productos.length) {
          var maxProducts = Math.min(pieza.productos.length, 3);
          html += '<div class="cv-product-grid">';
          for (var p = 0; p < maxProducts; p++) {
            var prod = pieza.productos[p];
            var prodHandle = prod.handle || '';
            var prodTitle = prod.title || prod.name || prod.nombre || '';
            if (!prodTitle && prodHandle) {
              prodTitle = prodHandle.replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
            }
            if (!prodTitle) prodTitle = 'Ver producto';
            var prodUrl = prodHandle ? '/products/' + escapeHtml(prodHandle) : '/search?q=' + encodeURIComponent(prodTitle);
            html += '<div class="cv-product-card">';
            html += '<a href="' + prodUrl + '" class="cv-product-card__link">';
            if (prod.image_url || prod.image) {
              html += '<img src="' + escapeHtml(prod.image_url || prod.image) + '" alt="' + escapeHtml(prodTitle) + '" loading="lazy">';
            }
            html += '<div class="cv-product-info">';
            html += '<p class="cv-product-title">' + escapeHtml(prodTitle) + '</p>';
            html += renderPrice(prod.price);
            html += '</div></a>';
            if (prod.variant_id) {
              html += '<button type="button" class="cv-atc-btn" data-variant-id="' + escapeHtml(String(prod.variant_id)) + '">Agregar al carrito</button>';
            } else if (prodUrl) {
              html += '<a href="' + prodUrl + '" class="cv-atc-btn cv-atc-btn--link">Ver producto</a>';
            }
            html += '</div>';
          }
          html += '</div>';
        }
        var viewQuery = pieza.query || (pieza.nombre + ' ' + state.brand + ' ' + state.model);
        html += '<button type="button" class="cv-view-all-btn" data-query="' + escapeHtml(viewQuery) + '">Ver todos los resultados →</button>';
        html += '</div>';
      });

      // Single Celorecomiendo block below the whole diagnosis, contextualized to
      // the top pieza's first product (highest-confidence recommendation).
      var topPieza = filteredPiezas[0];
      var topProd = (topPieza && topPieza.productos && topPieza.productos.length) ? topPieza.productos[0] : null;
      if (topProd && topProd.handle && CR_API_BASE) {
        html += '<div class="cv-pieza-cr cr-root" data-cr-handle="' + escapeHtml(topProd.handle) + '"';
        if (topProd.variant_id) html += ' data-cr-variant="' + escapeHtml(String(topProd.variant_id)) + '"';
        html += '></div>';
      }
    } else {
      html += renderNoResultsMessage();
    }

    html += '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:20px;">';
    html += '<button type="button" class="cv-restart-btn" id="cv-restart-btn">↻ Diagnosticar otro dispositivo</button>';
    if (!hasResults) {
      var searchQuery = state.symptomLabel + ' ' + state.brand + ' ' + state.model;
      html += '<button type="button" class="cv-no-results__search-btn" data-search-query="' + escapeHtml(searchQuery) + '">Buscar en la tienda →</button>';
    }
    html += '</div>';

    resultsEl.innerHTML = html;

    bindResultEvents();
    initCelorecomiendoForPiezas();
  }

  function initCelorecomiendoForPiezas() {
    if (!CR_API_BASE) return;
    if (!window.Celorecomiendo || !window.Celorecomiendo.mount) {
      // Engine still loading; retry shortly.
      return setTimeout(initCelorecomiendoForPiezas, 100);
    }
    var roots = resultsEl.querySelectorAll('.cv-pieza-cr[data-cr-handle]');
    roots.forEach(function(root) {
      if (root.__crMounted) return;
      var handle = root.getAttribute('data-cr-handle');
      var variantId = root.getAttribute('data-cr-variant') || '';
      fetchProductInfo(handle).then(function(prod) {
        var variantsMap = {};
        (prod.variants || []).forEach(function(v) {
          variantsMap[v.id] = (typeof v.price === 'number') ? (v.price / 100) : parseFloat(v.price);
        });
        var defaultPrice = (typeof prod.price === 'number') ? (prod.price / 100) : parseFloat(prod.price) || 0;
        var pid = prod.id ? String(prod.id) : '';
        window.Celorecomiendo.mount(root, {
          apiBase: CR_API_BASE,
          productId: pid,
          productGid: pid ? 'gid://shopify/Product/' + pid : '',
          productTitle: prod.title || '',
          productPriceDefault: defaultPrice,
          productVariantsMap: variantsMap,
          customerGid: CUSTOMER_GID,
          atcVariantId: variantId || (prod.variants && prod.variants[0] ? prod.variants[0].id : ''),
          hideValueBanner: true,
          hideAddToCart: true,
          scrollOnExpand: false
        });
      }).catch(function() { /* silent */ });
    });
  }

  function renderNoResultsMessage() {
    var html = '<div class="cv-no-results">';
    html += '<div class="cv-no-results__icon">';
    html += '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ff9b00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
    html += '</div>';
    html += '<p class="cv-no-results__title">No encontramos repuestos exactos</p>';
    html += '<p class="cv-no-results__text">Para tu ' + escapeHtml(state.brand) + ' ' + escapeHtml(state.model) + ' no pudimos identificar una pieza específica con suficiente confianza. Te recomendamos visitar un taller cercano para una revisión profesional.</p>';
    html += '</div>';
    return html;
  }

  // Removed: lite Talleres section (renderTalleresSection / initTalleresSection /
  // fetchTalleres / renderTalleresList / showTalleresStatus). Replaced by per-pieza
  // mounts of the full Celorecomiendo engine via initCelorecomiendoForPiezas().
  function bindResultEvents() {
    var productCards = resultsEl.querySelectorAll('.cv-product-card');
    productCards.forEach(function(card) {
      var link = card.querySelector('.cv-product-card__link');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      function navigateToProduct(e) {
        if (e && e.target && e.target.closest('.cv-atc-btn')) return;
        if (e) e.preventDefault();
        closeModal();
        setTimeout(function() {
          window.location.href = href;
        }, 50);
      }
      card.addEventListener('click', navigateToProduct);
      link.addEventListener('click', function(e) {
        e.stopPropagation();
        navigateToProduct(e);
      });
    });

    var viewAllBtns = resultsEl.querySelectorAll('.cv-view-all-btn');
    viewAllBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var query = btn.getAttribute('data-query');
        closeModal();
        var searchInput = document.querySelector('.search-bar__input');
        if (searchInput) {
          searchInput.value = query;
          var form = searchInput.closest('form');
          if (form) form.submit();
        } else {
          window.location.href = '/search?q=' + encodeURIComponent(query);
        }
      });
    });

    var restartBtn = document.getElementById('cv-restart-btn');
    if (restartBtn) {
      restartBtn.addEventListener('click', function() {
        resetWizard();
      });
    }

    var searchBtns = resultsEl.querySelectorAll('.cv-no-results__search-btn');
    searchBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var query = btn.getAttribute('data-search-query');
        closeModal();
        window.location.href = '/search?q=' + encodeURIComponent(query);
      });
    });

    var atcBtns = resultsEl.querySelectorAll('.cv-atc-btn[data-variant-id]');
    atcBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Agregando...';
        btn.classList.add('cv-atc-btn--loading');
        var localeRoot = (window.theme && window.theme.localeRootUrl) || '';
        fetch(localeRoot + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
          credentials: 'same-origin'
        })
        .then(function(response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          btn.textContent = 'Agregado ✓';
          btn.classList.remove('cv-atc-btn--loading');
          btn.classList.add('cv-atc-btn--done');
          if (window.SideCart && typeof window.SideCart.open === 'function') {
            document.dispatchEvent(new CustomEvent('product:added'));
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          // Desktop only: guide the customer to the next step ("¿Quién te lo
          // instala?") by collapsing the recommended-parts list and auto-
          // expanding the Celorecomiendo workshops panel.
          var isDesktop = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
          if (isDesktop) {
            var piezaCards = resultsEl.querySelectorAll('.cv-pieza');
            piezaCards.forEach(function(p) { p.classList.add('cv-pieza--collapsed'); });
            var crRoot = resultsEl.querySelector('.cv-pieza-cr');
            if (crRoot && window.Celorecomiendo && typeof window.Celorecomiendo.expand === 'function') {
              // Mount of the Celorecomiendo block is async (waits for
              // /products/{handle}.js). Retry briefly so the auto-expand still
              // fires deterministically if ATC happens before mount completes.
              var attempts = 0;
              (function tryExpand() {
                if (crRoot.__crMounted) {
                  window.Celorecomiendo.expand(crRoot);
                } else if (attempts++ < 30) {
                  setTimeout(tryExpand, 100);
                }
              })();
            }
          }
          setTimeout(function() {
            btn.disabled = false;
            btn.textContent = originalText;
            btn.classList.remove('cv-atc-btn--done');
          }, 2000);
        })
        .catch(function() {
          btn.disabled = false;
          btn.textContent = originalText;
          btn.classList.remove('cv-atc-btn--loading');
          alert('No se pudo agregar al carrito. Intenta de nuevo.');
        });
      });
    });
  }

  function renderPrice(price) {
    var numPrice = typeof price === 'number' ? price : parseFloat(price);
    if (isNaN(numPrice) || numPrice <= 0) {
      return '<span class="cv-product-price">Q' + escapeHtml(String(price || '')) + '</span>';
    }
    if (IS_MAYORISTA && DISCOUNT_PERCENT > 0 && DISCOUNT_PERCENT < 100) {
      var wholesalePrice = numPrice * DISCOUNT_MULTIPLIER;
      return '<span class="cv-product-price--wholesale">Q' + escapeHtml(formatPrice(wholesalePrice)) + '</span>' +
             '<span class="cv-mayorista-badge">Precio Mayorista</span>';
    }
    return '<span class="cv-product-price">Q' + escapeHtml(formatPrice(numPrice)) + '</span>';
  }

  function renderBadge(prob) {
    var cls = 'low';
    var label = 'Posible';
    if (prob === 'muy_probable') { cls = 'high'; label = 'Muy probable'; }
    else if (prob === 'probable') { cls = 'medium'; label = 'Probable'; }
    return '<span class="cv-prob-badge ' + cls + '">' + label + '</span>';
  }

  function formatPrice(price) {
    if (typeof price !== 'number') return String(price || '');
    return price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function resetWizard() {
    state = { step: 0, brand: '', model: '', baseModel: '', submodelActive: false, symptom: '', symptomLabel: '', detail: '' };
    resultsEl.classList.remove('visible');
    resultsEl.innerHTML = '';
    loadingEl.classList.remove('visible');
    initStep0();
    showStep(0);
  }

  if (backBtn) {
    backBtn.addEventListener('click', function() {
      if (state.step > 0) {
        if (state.step === 4) {
          state.symptom = ''; state.symptomLabel = ''; state.detail = '';
          initStep2();
          showStep(3);
        } else if (state.step === 3) {
          state.model = ''; state.symptom = ''; state.symptomLabel = ''; state.detail = '';
          if (state.submodelActive) {
            initStep1b();
            showStep(2);
          } else {
            initStep1();
            showStep(1);
          }
        } else if (state.step === 2) {
          state.model = ''; state.baseModel = ''; state.submodelActive = false;
          state.symptom = ''; state.symptomLabel = ''; state.detail = '';
          initStep1();
          showStep(1);
        } else if (state.step === 1) {
          state.brand = ''; state.model = ''; state.baseModel = '';
          state.submodelActive = false;
          state.symptom = ''; state.symptomLabel = ''; state.detail = '';
          initStep0();
          showStep(0);
        }
      }
    });
  }

  initStep0();
  showStep(0);
})();
